var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "web-apps-list-page" },
    [
      _c("AppBreadCrumb", {
        attrs: {
          paths: [
            { title: _vm.$t("message.integrations") },
            { title: "Web Apps" },
          ],
        },
      }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        _c(
          "div",
          { staticClass: "webapp-cards p-2" },
          [
            _vm._l(_vm.webApps, function (app, index) {
              return _c(
                "div",
                {
                  key: app._id,
                  staticClass: "webapp-card",
                  class: { disabled: !app.enabled },
                },
                [
                  _c("div", { staticClass: "app-tags" }, [
                    app.isPublic
                      ? _c("span", { staticClass: "app-tag public" }, [
                          _vm._v("Public"),
                        ])
                      : _c("span", { staticClass: "app-tag private" }, [
                          _vm._v("Private"),
                        ]),
                    _vm._v(" "),
                    !app.enabled
                      ? _c("span", { staticClass: "app-tag disabled-tag" }, [
                          _vm._v("Disabled"),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.getInstalledCount(app._id) > 0
                      ? _c("span", { staticClass: "app-tag installed-tag" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.getInstalledCount(app._id)) +
                              " Kurulu\n                    "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-header" }, [
                    _c("div", { staticClass: "app-icon-container" }, [
                      _c(
                        "div",
                        {
                          staticClass: "app-icon",
                          style: { background: _vm.getGradient(index) },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(_vm._s(app.icon || "web")),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "app-info" },
                      [
                        _c(
                          "a-tooltip",
                          { attrs: { title: app.name, placement: "topLeft" } },
                          [
                            _c("div", { staticClass: "app-title-row" }, [
                              _c("h3", [_vm._v(_vm._s(app.name))]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-tooltip",
                          {
                            attrs: {
                              title:
                                app.description ||
                                "Modern ve ölçeklenebilir bir web uygulaması.",
                              placement: "topLeft",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "app-description-container" },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "app-description",
                                    class: {
                                      expanded: _vm.isExpanded(app._id),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          app.description ||
                                            "Modern ve ölçeklenebilir bir web uygulaması."
                                        ) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                app.description && app.description.length > 80
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "read-more-btn",
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleDescription(
                                              app._id
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.isExpanded(app._id)
                                                ? "Daha az göster"
                                                : "Devamını oku"
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "app-details" }, [
                    _vm.isSupsisSite || !app.isPublic
                      ? _c("div", { staticClass: "detail-item" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("link"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "detail-text" }, [
                            _vm._v(_vm._s(app.slug) + ".webapp.supsis.ai"),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-footer" }, [
                      _c("div", { staticClass: "detail-item" }, [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v("info_outline"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "detail-text" }, [
                          _vm._v("v" + _vm._s(app.version)),
                        ]),
                      ]),
                      _vm._v(" "),
                      app.metadata && app.metadata.fileCount
                        ? _c("div", { staticClass: "detail-item" }, [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("inventory_2"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "detail-text" }, [
                              _vm._v(_vm._s(app.metadata.fileCount) + " Dosya"),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      app.updatedAt
                        ? _c("div", { staticClass: "detail-item" }, [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("schedule"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "detail-text" }, [
                              _vm._v(_vm._s(_vm.formatDate(app.updatedAt))),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "app-actions" },
                    [
                      _c(
                        "a-button",
                        {
                          staticClass: "btn-install",
                          attrs: { type: "primary", disabled: !app.enabled },
                          on: {
                            click: function ($event) {
                              return _vm.installApp(app)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("add_circle"),
                          ]),
                          _vm._v(
                            "\n                        Kur\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          staticClass: "btn-open",
                          attrs: { disabled: !app.enabled },
                          on: {
                            click: function ($event) {
                              return _vm.openApp(app)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("launch"),
                          ]),
                          _vm._v(
                            "\n                        Aç\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isSupsisSite || !app.isPublic
                        ? [
                            _c(
                              "a-button",
                              {
                                staticClass: "btn-edit",
                                on: {
                                  click: function ($event) {
                                    return _vm.editApp(app)
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("settings"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                staticClass: "btn-delete",
                                attrs: { type: "danger", ghost: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.confirmDelete(app)
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("delete_outline"),
                                ]),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "supsis-code-card",
                on: { click: _vm.openCodeSupsis },
              },
              [
                _c("div", { staticClass: "code-icon" }, [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("code"),
                  ]),
                ]),
                _vm._v(" "),
                _c("h3", [_vm._v("Supsis Code")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "React, Vue veya HTML ile kodlayın, direkt Supsis'e yükleyin"
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cta-button" }, [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("open_in_new"),
                  ]),
                  _vm._v(
                    "\n                    code.supsis.ai'de Başla\n                "
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "new-app-card",
                on: {
                  click: function ($event) {
                    return _vm.$router.push("/integrations/webapps/new")
                  },
                },
              },
              [
                _c("span", { staticClass: "material-icons" }, [_vm._v("add")]),
                _vm._v(" "),
                _c("div", [_vm._v("Yeni Web App")]),
              ]
            ),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "header-content" }, [
        _c("h2", [_vm._v("Web Apps")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "Uygulamalarınızı yönetin, yeni entegrasyonlar keşfedin ve Supsis Code ile kendi web uygulamanızı yayınlayın."
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }